var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1684_8294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4362 30.6779C18.2296 31.4427 16.8565 31.9056 15.4331 32.0273C14.9989 30.4404 13.5592 29.3383 11.9141 29.3332H7.33073C5.30569 29.3332 3.66406 30.9748 3.66406 32.9998V51.3332C3.66406 53.3582 5.30569 54.9998 7.33073 54.9998H11.9141C13.5736 54.9933 15.0219 53.8729 15.4451 52.2682C16.2234 52.3091 16.9863 52.5015 17.6909 52.8347C18.0447 53.0024 18.383 53.2013 18.7221 53.3975C19.2282 53.7062 19.7554 53.9788 20.2997 54.2133C21.7191 54.755 23.2284 55.0219 24.7474 54.9998H41.2474C42.6029 54.9992 43.8475 54.2507 44.4835 53.0536C45.1196 51.8566 45.0433 50.4063 44.2852 49.2826C45.3598 48.9128 46.2009 48.0635 46.5603 46.9854C46.9197 45.9072 46.7564 44.7232 46.1186 43.7826C47.4661 43.3214 48.4211 42.117 48.563 40.6999C48.705 39.2827 48.0078 37.9129 46.7786 37.1936C47.3467 36.5381 47.6609 35.7006 47.6641 34.8332C47.6641 32.8081 46.0224 31.1665 43.9974 31.1665H32.4181C33.8517 28.4367 36.4569 22.3344 33.9214 17.8959C32.8058 15.9462 30.4747 14.4208 27.9988 15.6822C25.4156 16.9948 25.9941 19.5881 26.2727 20.8329C26.9831 24.0266 24.6832 27.3394 19.4362 30.6779ZM11.9141 53.1665H7.33073C6.31821 53.1665 5.4974 52.3457 5.4974 51.3332V32.9998C5.4974 31.9873 6.31821 31.1665 7.33073 31.1665H11.9141C12.9266 31.1665 13.7474 31.9873 13.7474 32.9998V51.3332C13.7474 52.3457 12.9266 53.1665 11.9141 53.1665ZM28.0621 20.4342C27.6477 18.5798 27.8338 17.8226 28.8302 17.3175C30.4472 16.4925 31.792 17.8675 32.3301 18.8071C35.07 23.6049 30.12 31.513 30.0696 31.5928C29.8908 31.875 29.8798 32.2321 30.0408 32.5248C30.2017 32.8176 30.5092 32.9996 30.8432 32.9998H43.9974C45.0099 32.9998 45.8307 33.8207 45.8307 34.8332C45.8307 35.8457 45.0099 36.6665 43.9974 36.6665H38.4974C37.9911 36.6665 37.5807 37.0769 37.5807 37.5832C37.5807 38.0894 37.9911 38.4998 38.4974 38.4998H44.9141C45.9266 38.4998 46.7474 39.3207 46.7474 40.3332C46.7474 41.3457 45.9266 42.1665 44.9141 42.1665H38.4974C37.9911 42.1665 37.5807 42.5769 37.5807 43.0832C37.5807 43.5894 37.9911 43.9998 38.4974 43.9998H43.0807C44.0933 43.9998 44.9141 44.8207 44.9141 45.8332C44.9141 46.8457 44.0933 47.6665 43.0807 47.6665H38.4974C37.9911 47.6665 37.5807 48.0769 37.5807 48.5832C37.5807 49.0894 37.9911 49.4998 38.4974 49.4998H41.2474C42.2599 49.4998 43.0807 50.3207 43.0807 51.3332C43.0807 52.3457 42.2599 53.1665 41.2474 53.1665H24.7474C23.4646 53.1889 22.1892 52.9674 20.9891 52.5138C20.5245 52.3112 20.0746 52.0765 19.6425 51.8117C19.2611 51.5898 18.878 51.3698 18.4811 51.1801C17.5703 50.7517 16.5856 50.5027 15.5807 50.4468V33.8716C17.303 33.719 18.9631 33.153 20.4198 32.2216C26.3873 28.4284 28.9586 24.462 28.0621 20.4342Z",
    fill: "url(#paint0_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5082 0.889848V0.909098V0.916432C38.5082 1.25376 38.4248 9.16643 31.1667 9.16643C30.6604 9.16643 30.25 9.57684 30.25 10.0831C30.25 10.5894 30.6604 10.9998 31.1667 10.9998C38.3964 10.9998 38.5073 18.9143 38.5082 19.2498C38.5014 19.756 38.9063 20.172 39.4125 20.1788C39.9188 20.1856 40.3347 19.7808 40.3416 19.2745V19.2553V19.2498C40.3416 18.9124 40.425 10.9998 47.6841 10.9998C48.1903 10.9998 48.6007 10.5894 48.6007 10.0831C48.6007 9.57684 48.1903 9.16643 47.6841 9.16643C40.4534 9.16643 40.3434 1.25193 40.3416 0.916432C40.3484 0.410171 39.9436 -0.00577552 39.4373 -0.01261C38.931 -0.0194446 38.5151 0.385421 38.5082 0.891682V0.889848ZM43.5041 10.0831C41.627 11.0733 40.1761 12.7149 39.424 14.6994C38.6724 12.7146 37.2213 11.0729 35.3439 10.0831C37.2213 9.0933 38.6724 7.45157 39.424 5.46677C40.1761 7.4513 41.627 9.0929 43.5041 10.0831Z",
    fill: "url(#paint1_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 11.9165V11.911C15.5818 11.4047 15.1702 10.9956 14.6639 10.9971C14.1577 10.9986 13.7485 11.4102 13.75 11.9165C13.75 12.1411 13.673 17.4165 9.16667 17.4165C8.66041 17.4165 8.25 17.8269 8.25 18.3332C8.25 18.8394 8.66041 19.2498 9.16667 19.2498C13.673 19.2498 13.75 24.5271 13.75 24.7498V24.7553C13.7515 25.2616 14.1632 25.6708 14.6694 25.6692C15.1757 25.6677 15.5849 25.2561 15.5833 24.7498C15.5833 24.5252 15.6603 19.2498 20.1667 19.2498C20.6729 19.2498 21.0833 18.8394 21.0833 18.3332C21.0833 17.8269 20.6729 17.4165 20.1667 17.4165C15.6603 17.4165 15.5833 12.1392 15.5833 11.9165ZM16.8153 18.3332C15.8871 18.9523 15.1445 19.8118 14.6667 20.8201C14.1888 19.8118 13.4462 18.9523 12.518 18.3332C13.4464 17.7142 14.1891 16.8546 14.6667 15.8462C15.1443 16.8546 15.887 17.7142 16.8153 18.3332Z",
    fill: "url(#paint2_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7448 19.25C46.2385 19.25 45.8281 19.6604 45.8281 20.1667V22C45.8281 22.5063 46.2385 22.9167 46.7448 22.9167C47.2511 22.9167 47.6615 22.5063 47.6615 22V20.1667C47.6615 19.6604 47.2511 19.25 46.7448 19.25Z",
    fill: "url(#paint3_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7448 28.4167C47.2511 28.4167 47.6615 28.0063 47.6615 27.5V25.6667C47.6615 25.1604 47.2511 24.75 46.7448 24.75C46.2385 24.75 45.8281 25.1604 45.8281 25.6667V27.5C45.8281 28.0063 46.2385 28.4167 46.7448 28.4167Z",
    fill: "url(#paint4_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5807 24.7493H50.4141C50.9203 24.7493 51.3307 24.3389 51.3307 23.8327C51.3307 23.3264 50.9203 22.916 50.4141 22.916H48.5807C48.0745 22.916 47.6641 23.3264 47.6641 23.8327C47.6641 24.3389 48.0745 24.7493 48.5807 24.7493Z",
    fill: "url(#paint5_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9141 24.7493C45.4203 24.7493 45.8307 24.3389 45.8307 23.8327C45.8307 23.3264 45.4203 22.916 44.9141 22.916H43.0807C42.5745 22.916 42.1641 23.3264 42.1641 23.8327C42.1641 24.3389 42.5745 24.7493 43.0807 24.7493H44.9141Z",
    fill: "url(#paint6_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6392 8.43932L25.0142 9.81432C25.3739 10.1617 25.9457 10.1567 26.2992 9.80315C26.6528 9.44956 26.6578 8.87783 26.3104 8.51815L24.9354 7.14315C24.7053 6.90486 24.3644 6.80929 24.0439 6.89318C23.7235 6.97707 23.4732 7.22736 23.3893 7.54785C23.3054 7.86835 23.401 8.20917 23.6392 8.43932Z",
    fill: "url(#paint7_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8901 5.68923C21.2498 6.03662 21.8215 6.03165 22.1751 5.67806C22.5287 5.32447 22.5337 4.75274 22.1863 4.39306L20.8113 3.01806C20.4516 2.67067 19.8799 2.67564 19.5263 3.02923C19.1727 3.38282 19.1677 3.95455 19.5151 4.31423L20.8901 5.68923Z",
    fill: "url(#paint8_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5184 9.81432C19.8763 10.1722 20.4566 10.1722 20.8146 9.81432L22.1896 8.43932C22.4278 8.20917 22.5234 7.86835 22.4395 7.54785C22.3556 7.22736 22.1053 6.97707 21.7849 6.89318C21.4644 6.80929 21.1235 6.90486 20.8934 7.14315L19.5184 8.51815C19.1605 8.87611 19.1605 9.45636 19.5184 9.81432Z",
    fill: "url(#paint9_linear_1684_8294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2915 5.9579C24.5346 5.95785 24.7677 5.86124 24.9396 5.68932L26.3146 4.31432C26.5529 4.08417 26.6484 3.74335 26.5646 3.42285C26.4807 3.10236 26.2304 2.85207 25.9099 2.76818C25.5894 2.68429 25.2486 2.77986 25.0184 3.01815L23.6434 4.39315C23.3813 4.65531 23.3029 5.04952 23.4448 5.392C23.5866 5.73448 23.9208 5.95782 24.2915 5.9579Z",
    fill: "url(#paint10_linear_1684_8294)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1684_8294",
    x1: 26.1226,
    y1: 15.2217,
    x2: 26.1226,
    y2: 55.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1684_8294",
    x1: 39.4254,
    y1: -0.0126953,
    x2: 39.4254,
    y2: 20.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1684_8294",
    x1: 14.6667,
    y1: 10.9971,
    x2: 14.6667,
    y2: 25.6692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1684_8294",
    x1: 46.7448,
    y1: 19.25,
    x2: 46.7448,
    y2: 22.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1684_8294",
    x1: 46.7448,
    y1: 24.75,
    x2: 46.7448,
    y2: 28.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1684_8294",
    x1: 49.4974,
    y1: 22.916,
    x2: 49.4974,
    y2: 24.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1684_8294",
    x1: 43.9974,
    y1: 22.916,
    x2: 43.9974,
    y2: 24.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1684_8294",
    x1: 24.9636,
    y1: 6.86328,
    x2: 24.9636,
    y2: 10.0716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1684_8294",
    x1: 20.8507,
    y1: 2.76074,
    x2: 20.8507,
    y2: 5.94655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1684_8294",
    x1: 20.8597,
    y1: 6.86328,
    x2: 20.8597,
    y2: 10.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1684_8294",
    x1: 24.9847,
    y1: 2.73828,
    x2: 24.9847,
    y2: 5.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1684_8294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.7b1a1961f27dd85b6b5f658c986f80df.svg";
export { ForwardRef as ReactComponent };